import ApiError from '../models/api-error';
import ErrorCode from '../models/error-code';

const FIELD_BY_ERROR_CODE: { [code: number]: string } = {
  [ErrorCode.WeakPassword]: 'password',
  [ErrorCode.EmailAlreadyExists]: 'email',
};

/** The form field an API error belongs to, or null when it belongs to no field in particular. */
export const getErrorField = (error: ApiError) => {
  if (!error || error.code === undefined || error.code === null) return null;

  return FIELD_BY_ERROR_CODE[error.code] || null;
};

// A network failure or a 500 rejects with ErrorCode.Unknown and 'Erro desconhecido', which tells the
// user nothing — those keep the caller's own wording.
export const getErrorMessage = (error: ApiError, fallback: string) => {
  if (!error || !error.message || error.code === ErrorCode.Unknown) return fallback;

  return error.message;
};
